<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-row class="mx-0">
      <h2>{{ $t('global.menu.backoffice.productgroup') }}</h2>
      <v-col cols="12" class="align-items-center text-left">
        <v-label class="mr-4">{{ $t('shop.home.discover.search') }}</v-label>
        <v-autocomplete v-model="ProductGroupSearch" @update:search="onSearch" variant="outlined" density="compact"
          :hide-details="true" :items="filteredItems" item-title="value" return-object="true"
          :placeholder="$t('shop.profile.productGroupDialog.searchText')" @update:model-value="onSelectItem"
          v-bind:menu="menu">
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-list-item @click="back" :disabled="this.latestParent.length == 1">
          <template v-slot:prepend>
            <v-icon>mdi-chevron-left</v-icon>
          </template>
          {{ $t('entity.action.back') }}
        </v-list-item>
        <v-treeview v-model:selected="parent" :items="productGroups"
          :item-title="`translations[${selectedLanguage.toUpperCase()}].value`" item-value="id" activatable selectable
          @click:open="getChildren" return-object density="compact">
          <template v-slot:append="{ item }">
            <v-btn icon color="primary" size="x-small" flat
              @click.stop="editGroup(item)"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn icon color="error" size="x-small" flat
              @click.stop="deleteGroup(item.id)"><v-icon>mdi-delete</v-icon></v-btn>
          </template>
        </v-treeview>
      </v-col>
      <v-col cols="12" md="6" align-self="start">
        <v-form @submit.prevent="addCategory" class="text-right">
          <v-col class="align-items-center text-left">
            <!-- ID:{{ newGroup.id }} -->
            <v-label class="mr-4">{{ $t('global.form.name') }} (german)</v-label>
            <v-text-field v-model="newGroup.nameDe" variant="outlined" density="compact" :hide-details="true">
            </v-text-field>
          </v-col>
          <v-col class="align-items-center text-left">
            <v-label class="mr-4">{{ $t('global.form.name') }} (english)</v-label>
            <v-text-field v-model="newGroup.nameEn" variant="outlined" density="compact" :hide-details="true">
            </v-text-field>
          </v-col>
          <v-col class="align-items-center text-left">
            <v-label class="mr-4">{{ $t('fairling.stream.connect.productGroups.topgroup') }}</v-label>
            <v-select v-model="newGroup.parentId" :items="productGroups" item-value="id" return-object
              :item-title="`translations[${selectedLanguage.toUpperCase()}].value`" variant="outlined" density="compact"
              :hide-details="true" @update:model-value="updateParent">
              <template v-slot:selection="{ item }">
                {{ !item.raw.translations ? item.raw.value : item.raw.translations[selectedLanguage.toUpperCase()].value
                }}
              </template>
            </v-select>
          </v-col>
          <template v-if="edit">
            <v-btn variant="flat" size="large" color="default" rounded="xl"
              class="white--text mb-2 mr-2 find-favourites-button" @click="cancelEditing">{{
                $t('entity.action.cancel') }}</v-btn>
            <v-btn variant="flat" size="large" color="primary" rounded="xl" @click="save"
              class="white--text mb-2 find-favourites-button">{{
                $t('entity.action.save') }}</v-btn>
          </template>
          <v-btn v-else variant="flat" size="large" color="primary" rounded="xl"
            class="white--text mb-2 find-favourites-button" @click="save">{{
              $t('entity.action.add') }}</v-btn>
        </v-form>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {

  setup() {
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    const filteredItems = ref([]);
    const { proxy } = getCurrentInstance();
    const username = localStorage.getItem("username");
    const softToken = localStorage.getItem("softToken");
    const hardToken = localStorage.getItem("hardToken");
    const ProductGroupSearch = ref('')
    const newGroup = ref({ nameEn: '', nameDe: '', parentId: null });

    const onSearch = async (searchTerm) => {
      if (!searchTerm || searchTerm.length < 2) {
        filteredItems.value = []; // Clear the items when input is empty
        return;
      }
      try {
        const response = await proxy.$axios.get("/shop/productGroup/search", {
          headers: {
            'X-Auth-HARDTOKEN': hardToken,
            'X-Auth-SOFTTOKEN': softToken,
            'X-Auth-USER': username
          },
          params: {
            keyword: searchTerm,
            language: selectedLanguage.toUpperCase()
          },
        });

        // Update filteredItems with the API response
        filteredItems.value = response.data.data || [];
      } catch (error) {
        console.error("Error fetching search results:", error);
        filteredItems.value = [];
      }
    };

    const onSelectItem = async (item) => {
      if (!item) return;
      parent.value = null;
      // Find selected item
      // selectGroup(item);

      proxy.searchParent(item);
      ProductGroupSearch.value = null;
    };

    const addAlias = async () => {
      // {name: "Patrone"} POST /backoffice/productgroup/19b5407a-26d8-44ab-a63e-5c7256e72283/alias
      const copy = { name: newGroup.value.name }
      try {
        const response = await proxy.$axios.put(`/backoffice/productgroup/${newGroup.value.id}/alias`, copy, {
          headers: {
            'X-Auth-HARDTOKEN': hardToken,
            'X-Auth-SOFTTOKEN': softToken,
            'X-Auth-USER': username
          },
        });

        if (response.data.status == "OK") {
          proxy.getChildren('same');
        }
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    }

    const save = async () => {
      // { name: "Patronen", parents: ["3D-Drucker"] } POST /backoffice/productgroup
      // {value: "3D Printer", translationLanguage: "EN"} PUT /backoffice/productgroup/19b5407a-26d8-44ab-a63e-5c7256e72283/translation/811d487c-849e-4ddb-afad-d1bac7262c86
      // TODO BACKEND EDITING TRANSLATION DE EN ONE OBJ & CREATE WITH TRANSLATIONS
      if (newGroup.value.id) {
        const copy = { id: newGroup.value.id, name: newGroup.value.nameDe, parents: [newGroup.value.parentId.name] }
        console.log(copy)
        try {
          const response = await proxy.$axios.put(`/backoffice/productgroup/${newGroup.value.id}`, copy, {
            headers: {
              'X-Auth-HARDTOKEN': hardToken,
              'X-Auth-SOFTTOKEN': softToken,
              'X-Auth-USER': username
            },
          });

          if (response.data.status == "OK") {
            proxy.getChildren('same');
          }
        } catch (error) {
          console.error("Error fetching search results:", error);
        }
      } else {
        const copy = { name: newGroup.value.nameDe, parents: [newGroup.value.parentId.name] }
        console.log(copy)
        try {
          const response = await proxy.$axios.post(`/backoffice/productgroup`, copy, {
            headers: {
              'X-Auth-HARDTOKEN': hardToken,
              'X-Auth-SOFTTOKEN': softToken,
              'X-Auth-USER': username
            },
          });

          if (response.data.status == "OK") {
            proxy.getChildren('same');
          }
        } catch (error) {
          console.error("Error fetching search results:", error);
        }
      }
    }

    const remove = async (item) => {
      try {
        const response = await proxy.$axios.delete(`/backoffice/productgroup/${item}`, {
          headers: {
            'X-Auth-HARDTOKEN': hardToken,
            'X-Auth-SOFTTOKEN': softToken,
            'X-Auth-USER': username
          },
        });

        if (response.data.status == "OK") {
          proxy.getChildren('same');
        }
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    }

    return {
      selectedLanguage,
      onSearch,
      onSelectItem,
      filteredItems,
      newGroup,
      save,
      remove
    }
  },
  data() {
    return {
      categories: [
        {
          id: 1, name: "Electronics / Elektronik", children: [
            { id: 2, name: "Laptops / Laptops", children: [] },
            { id: 3, name: "Smartphones / Smartphones", children: [] }
          ]
        },
        {
          id: 4, name: "Home & Kitchen / Haushalt & Küche", children: [
            { id: 5, name: "Furniture / Möbel", children: [] },
            { id: 6, name: "Appliances / Haushaltsgeräte", children: [] }
          ]
        }
      ],
      // newGroup: { nameEn: '', nameDe: '', parentId: null },
      selected: [],
      productGroups: [],
      latestParent: [{ id: 'none' }],
      staticProductGroups: [],
      edit: false,
      search: null,
    };
  },
  computed: {
    categoryOptions() {
      return [{ id: null, name: 'None' }, ...this.categories];
    }
  },

  mounted() {
    this.fetchProductGroups();
  },

  methods: {
    fetchProductGroups() {
      // const softToken = localStorage.getItem("softToken");
      const hardToken = localStorage.getItem("hardToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/shop/productGroup", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-USER': username
        },
      })
        .then(this.productGroupFetched)
        .catch(error => {

          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    productGroupFetched(response) {
      if (response.data.status == "OK") {
        this.productGroups = response.data.data.children.map(element => ({
          children: [],
          ...element
        }));
        this.staticProductGroups = this.productGroups;
      }
    },
    searchParent(val) {
      this.newGroup.parentId = val;
      var parent = val;
      this.latestParent.push(parent);
      this.fetchChildren(val.id);
    },
    updateParent(val) {
      var parent = this.productGroups.find((group) => group.id === val.id)
      // this.latestParent.push(parent);
      // this.newGroup.parentId = val.id;
      this.fetchChildren(val.id);
    },
    getChildren(val) {
      if (!val) return;
      if (val == 'same') {
        val = {}
        val.id = this.newGroup.parentId;
      } else {
        this.newGroup.parentId = val.id;
      }
      this.resetGroup();
      console.log("fetchChildren for" + val.id.id)
      this.fetchChildren(val.id.id);
    },
    resetGroup() {
      this.newGroup.id = null;
      this.newGroup.nameDe = '';
      this.newGroup.nameEn = '';
    },
    back() {
      var newparent = this.latestParent[this.latestParent.length - 2]
      var latestParent = this.latestParent.pop()
      this.resetGroup();
      if (newparent.id == 'none') {
        this.newGroup.parentId = null;
      } else {
        this.newGroup.parentId = newparent;
      }
      this.fetchChildren(newparent.id);
    },
    fetchChildren(id) {
      if (id == 'none') {
        if (this.staticProductGroups != null) {
          this.productGroups = this.staticProductGroups;
        }
        return;
      }
      const hardToken = localStorage.getItem("hardToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/shop/productGroup", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-USER': username
        },
        params: {
          id: id,
        }
      })
        .then(this.addChildren)
        .catch(error => {
          console.error(error)
          // You can handle specific error codes here, for example, a 401 Unauthorized
          // if (error.response && error.response.status === 401 || error.response.status === 403 || error.response.status === 403) {
          //   // Handle token expiration or unauthorized error
          //   console.log("Session expired or unauthorized. Please log in again.");
          //   _this.$router.replace('/login');
          //   // Optionally log the user out or redirect to login page
          // }
        });
    },
    addChildren(response) {
      console.log(response)
      var parent;
      // if (this.latestParent.length == 0) {
      // }
      console.log('this.newGroup.parentId', this.newGroup.parentId)

      parent = this.productGroups.find((group) => group.id === this.newGroup.parentId.id)
      console.log('parent', parent)
      // console.log('1parent', parent)
      this.productGroups = response.data.data.children.map(element => ({
        children: [],
        ...element
      }));
      // if (response.data.data.children.length != 0) {
      // }
      // console.log('2parent', parent)
      if (parent) {
        this.latestParent.push(parent);
      }
      console.log(this.latestParent)
    },
    getActiveValue(value) {
      this.parent = value;
    },
    addCategory() {
      if (!this.newGroup.nameEn || !this.newGroup.nameDe) return;
      const newCat = {
        id: Date.now(),
        name: `${this.newGroup.nameEn} / ${this.newGroup.nameDe}`,
        children: [],
      };
      if (this.newGroup.parentId) {
        const parent = this.findCategory(this.newGroup.parentId, this.categories);
        if (parent) parent.children.push(newCat);
      } else {
        this.categories.push(newCat);
      }
      this.newGroup = { nameEn: '', nameDe: '', parentId: null };
    },
    findCategory(id, items) {
      for (let item of items) {
        if (item.id === id) return item;
        if (item.children.length) {
          const found = this.findCategory(id, item.children);
          if (found) return found;
        }
      }
      return null;
    },
    cancelEditing() {
      this.edit = false;
      this.resetGroup();
    },
    editGroup(item) {
      this.edit = true;

      this.newGroup.id = item.id;
      this.newGroup.nameDe = item.translations['DE'].value;
      this.newGroup.nameEn = item.translations['EN'].value;
    },
    deleteGroup(id) {
      this.categories = this.removeCategory(id, this.categories);
      console.log("remove " + id);
      this.remove(id)
    },
    removeCategory(id, items) {
      return items.filter(item => {
        if (item.id === id) return false;
        if (item.children.length) item.children = this.removeCategory(id, item.children);
        return true;
      });
    }
  }
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  max-width: 1170px;
  margin-top: 40px;
}
</style>

<style></style>

<style></style>